// NOTE LpFeature.tsxで使用している画像（feature_03.svg）に数字が入っているためここの数字を変更する場合は画像の差し替えも必要
export const PROGRAM_COUNT = 150;
